import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const procurementStatusListWidget: DashboardWidgetConfiguration = {
  widgetId: "procurement.status-list",
  name: "Purchases by status",
  description: "Purchases by status as a compact RQL list.",
  apps: [
    "home",
    "procurement",
  ],
  template: "list",
  query: {
    kind: "single",
    query: {
      version: 1,
      source: "procurement.purchases",
      ...period(30),
      select: [
        {
          type: "field",
          field: "status",
          as: "status",
        },
        {
          type: "aggregate",
          function: "count_distinct",
          field: "purchase_id",
          as: "purchases",
        },
      ],
      group_by: [
        {
          field: "status",
        },
      ],
      order_by: [
        {
          ref: "purchases",
          direction: "desc",
        },
      ],
      limit: 8,
    },
  },
  inputs: {
    title: "Purchases by status",
    columns: [
      {
        key: "status",
        label: "Status",
      },
      {
        key: "purchases",
        label: "Purchases",
        align: "end",
        format: "number",
      },
    ],
    maxRows: 8,
    showAccountTypeDescription: false,
  },
  dummyData: {
    rows: [
      {
        status: "Confirmed",
        purchases: 19,
      },
      {
        status: "RFQ",
        purchases: 11,
      },
      {
        status: "Draft",
        purchases: 7,
      },
    ],
  },
  limits: {
    minWidth: 3,
    maxWidth: 12,
    minHeight: 3,
    maxHeight: 8,
    defaultWidth: 6,
    defaultHeight: 4,
  },
};
